import React from 'react';
import styles from '../../styles/stepIndicator.module.scss'; // Import as 'styles'

const StepIndicator = ({ currentStep, totalSteps }) => {
    console.log('currentStep', currentStep);
    return (
        <div className={styles.stepIndicator}> {/* Use styles.stepIndicator */}
            <div className={styles.stepIndicator__container}>
                {Array.from({ length: totalSteps }).map((_, index) => (
                    <div
                        key={index}
                        className={`${styles.stepIndicator__dash} ${
                            index <= currentStep ? styles.active : ''
                        }`}
                    />
                ))}
            </div>
        </div>
    );
};

export default StepIndicator;